import "./newClaim.css";
import React, { useContext, useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Grid, MenuItem, Select, Snackbar, Alert } from "@mui/material";
import { OrderContext } from "../../context/orderContext/OrderContext";
import { AuthContext } from "../../context/authContext/AuthContext";
import { createClaim } from "../../context/claimContext/ClaimApiCalls";
import { ClaimContext } from "../../context/claimContext/ClaimContext";
import Dropzone from "react-dropzone";
import DeleteIcon from "@mui/icons-material/Delete";
import glass_arrangement from "../../images/glass_arrangement.png";
import {
  validateFiled,
  validateEmail,
} from "../../components/validation/Validation";
import {
  UnitDefectTypes,
  GlassDefectTypes,
  AccessoriesDefectTypes,
  FittingDefectTypes,
  DefectNoticeLoactions,
  GlassLocations,
} from "../../data/NewClaimConstants";

const useUnload = (fn) => {
  const cb = useRef(fn);

  useEffect(() => {
    const onUnload = cb.current;
    window.addEventListener("beforeunload", onUnload);
    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };
  }, [cb]);
};

export default function NewClaim() {
  const { posted, isFetching, dispatch } = useContext(ClaimContext);
  const { orders } = useContext(OrderContext);
  const { user } = useContext(AuthContext);

  const params = useParams();
  const navigate = useNavigate();

  let orderData = null;
  if (orders.length < 1) {
    orderData = JSON.parse(localStorage.getItem("claimOrder"));
  } else {
    orderData = orders.find((x) => x.id === params.orderId);
  }

  useUnload((e) => {
    e.preventDefault();
    localStorage.setItem("claimOrder", JSON.stringify(orderData));
  });

  const [position, setPosition] = useState("");
  const [dealerCompany, setDealerCompany] = useState(user.salesforceAccountName);
  const [suppliedName, setDealerContactPerson] = useState(user.contactPerson);
  const [suppliedPhone, setDealerPhoneNumber] = useState(user.phoneNumber);
  const [suppliedEmail, setDealerEmail] = useState(user.email);
  const [installLocation, setInstallLocation] = useState("");
  const [endCustomerContact, setEndCustomerContact] = useState("");
  const [endCustomerPhone, setEndCustomerPhone] = useState("");
  const [endCustomerEmail, setEndCustomerEmail] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [defectNoticeLocation, setDefectNoticeLocation] = useState([]);
  const [unitDefects, setUnitDefects] = useState([]);
  const [glassDefects, setGlassDefects] = useState([]);
  const [fittingDefects, setFittingDefects] = useState([]);
  const [accessoriesDefects, setAccessoriesDefects] = useState([]);
  const [glassDamageLocation, setGlassDamageLocation] = useState([]);

  const [errorMsg, setErrorMsg] = useState("");
  const [validInfo, setValidInfo] = useState({
    preferredSolution: true,
    description: true,
    endCustomerContact: true,
    endCustomerPhone: true,
    endCustomerEmail: true,
    position: true,
    dealerCompany: true,
    suppliedName: true,
    suppliedPhone: true,
    suppliedEmail: true,
  });

  const validate = () => {
    let rawValidInfo = {};
    rawValidInfo = { ...rawValidInfo, description: validateFiled(description) };
    rawValidInfo = {
      ...rawValidInfo,
      endCustomerContact: validateFiled(endCustomerContact),
    };
    rawValidInfo = {
      ...rawValidInfo,
      endCustomerEmail: validateEmail(endCustomerEmail),
    };
    rawValidInfo = {
      ...rawValidInfo,
      endCustomerPhone: validateFiled(endCustomerPhone),
    };
    rawValidInfo = { ...rawValidInfo, position: validateFiled(position) };
    rawValidInfo = {
      ...rawValidInfo,
      dealerCompany: validateFiled(dealerCompany),
    };
    rawValidInfo = {
      ...rawValidInfo,
      suppliedName: validateFiled(suppliedName),
    };
    rawValidInfo = {
      ...rawValidInfo,
      suppliedPhone: validateFiled(suppliedPhone),
    };
    rawValidInfo = {
      ...rawValidInfo,
      suppliedEmail: validateEmail(suppliedEmail),
    };

    setValidInfo(rawValidInfo);
    return (
      Object.values(rawValidInfo).filter(function (valid) {
        return valid === false;
      }).length < 1
    );
  };

  const handleNewClaimSubmit = (e) => {
    e.preventDefault();

    if (!validate()) {
      setErrorMsg("Missing / Incorrect fileds. Pleas correct the form.");
      return;
    }

    setErrorMsg("");

    let formData = new FormData();
    formData.append("orderId", orderData.id);
    formData.append("accountId", user.salesforceAccountId);
    formData.append("position", position);
    formData.append("description", description);
    formData.append("directCustomerContact", suppliedName);
    formData.append("directCustomerPhone", suppliedPhone);
    formData.append("directCustomerEmail", suppliedEmail);
    formData.append("installLocation", installLocation);
    formData.append("endCustomerContact", endCustomerContact);
    formData.append("endCustomerEmail", endCustomerEmail);
    formData.append("endCustomerPhone", endCustomerPhone);
    formData.append("damageNoticeLocation", defectNoticeLocation.join(";"));
    formData.append("unitDamage", unitDefects.join(";"));
    formData.append("glassDamage", glassDefects.join(";"));
    formData.append("fittingDamage", fittingDefects.join(";"));
    formData.append("accessoriesDamage", accessoriesDefects.join(";"));
    formData.append("glassDamageLocation", glassDamageLocation.join(";"));
    formData.append("keyAccountManagerId", orderData.keyAccountManager.id);

    [...images].forEach((file) => {
      formData.append("atachment", file);
    });

    createClaim(formData, dispatch);
  };

  if (orderData == null || orderData.id == null) {
    return (
      <div>
        <h3>Order not found. Contact administrator.</h3>
      </div>
    );
  }

  const handledefectNoticeLocationChange = (event) => {
    const {
      target: { value },
    } = event;

    setDefectNoticeLocation(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleUnitDefectChange = (event) => {
    const {
      target: { value },
    } = event;

    setUnitDefects(typeof value === "string" ? value.split(",") : value);
  };

  const handleGlassDefectChange = (event) => {
    const {
      target: { value },
    } = event;

    setGlassDefects(typeof value === "string" ? value.split(",") : value);
  };

  const handleFittingDefectChange = (event) => {
    const {
      target: { value },
    } = event;

    setFittingDefects(typeof value === "string" ? value.split(",") : value);
  };

  const handleAccessoriesDefectChange = (event) => {
    const {
      target: { value },
    } = event;

    setAccessoriesDefects(typeof value === "string" ? value.split(",") : value);
  };

  const handleGlassDamageLocationChange = (event) => {
    const {
      target: { value },
    } = event;

    setGlassDamageLocation(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleImageSelection = (files) => {
    Array.from(files).forEach((file) => {
      if (
        images.length > 0 &&
        images.filter((f) => f.path === file.path).length > 0
      ) {
        return;
      }
      setImages((images) => [...images, file]);
    });
  };

  const handleAttachmentRemove = (path) => {
    setImages(images.filter((file) => file.path !== path));
  };

  const handleClose = (event, reason) => {
    navigate("/claims/");
  };

  return (
    <div className="newClaimContainer">
      <Snackbar
        open={posted}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          The claim was successfully submitted!
        </Alert>
      </Snackbar>
      <h1 className="newClaimTitle">Register a Claim</h1>
      <div className="newClaimWrapper" spacing={2}>
        <form className="newClaimForm">
          <h3 className="newClaimSubTitle">Order Details</h3>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Order Number:</label>
                <input
                  readOnly
                  type="text"
                  placeholder="Aradas Order Number"
                  value={orderData.orderNumber}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Order Reference:</label>
                <input
                  readOnly
                  type="text"
                  placeholder="Order Reference"
                  value={orderData.reference}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Date of Approval:</label>
                <input
                  readOnly
                  type="text"
                  placeholder="Date of Approval"
                  value={orderData.dateOfApproval}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Key Account Manager:</label>
                <input
                  readOnly
                  type="text"
                  placeholder="Key Account Manager"
                  value={orderData.keyAccountManager.name}
                />
              </div>
            </Grid>
          </Grid>
          <h3 className="newClaimSubTitle">Dealer Contact Details</h3>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Company Name:</label>
                <input
                  readOnly
                  type="text"
                  placeholder="Company Name"
                  onChange={(e) => setDealerCompany(e.target.value)}
                  value={dealerCompany}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Contact Person:</label>
                <input
                  className={validInfo.suppliedName === true ? "" : "error"}
                  type="text"
                  placeholder="Name, Surname"
                  onChange={(e) => setDealerContactPerson(e.target.value)}
                  value={suppliedName}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Email Address:</label>
                <input
                  className={validInfo.suppliedEmail === true ? "" : "error"}
                  type="text"
                  placeholder="Email Address"
                  onChange={(e) => setDealerEmail(e.target.value)}
                  value={suppliedEmail}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Phone Number:</label>
                <input
                  className={validInfo.suppliedPhone === true ? "" : "error"}
                  type="text"
                  placeholder="Phone Number"
                  onChange={(e) => setDealerPhoneNumber(e.target.value)}
                  value={suppliedPhone}
                />
              </div>
            </Grid>
          </Grid>
          <h3 className="newClaimSubTitle">End-customer Contact Details</h3>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Location of installed products:</label>
                <input
                  type="text"
                  placeholder="Location"
                  onChange={(e) => setInstallLocation(e.target.value)}
                  value={installLocation}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Contact Person:</label>
                <input
                  className={
                    validInfo.endCustomerContact === true ? "" : "error"
                  }
                  type="text"
                  placeholder="Name, Surname"
                  onChange={(e) => setEndCustomerContact(e.target.value)}
                  value={endCustomerContact}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Email Address:</label>
                <input
                  className={validInfo.endCustomerEmail === true ? "" : "error"}
                  type="text"
                  placeholder="Email Address"
                  onChange={(e) => setEndCustomerEmail(e.target.value)}
                  value={endCustomerEmail}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Phone Number:</label>
                <input
                  className={validInfo.endCustomerPhone === true ? "" : "error"}
                  type="text"
                  placeholder="Phone Number"
                  onChange={(e) => setEndCustomerPhone(e.target.value)}
                  value={endCustomerPhone}
                />
              </div>
            </Grid>
          </Grid>
          <div className="defectTypeContainer">
            <div className="newClaimLeft">
              <h3 className="newClaimSubTitle">Claim Details</h3>
            </div>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>*Specify positions from the order:</label>
                <input
                  className={validInfo.position === true ? "" : "error"}
                  type="text"
                  placeholder="(e.g.: L1, D1...)"
                  onChange={(e) => setPosition(e.target.value)}
                  value={position}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Where was the problem noticed:</label>
                <Select
                  multiple
                  className="newClaimSelect"
                  value={defectNoticeLocation}
                  onChange={handledefectNoticeLocationChange}
                >
                  {DefectNoticeLoactions.map((defectType) => (
                    <MenuItem
                      className="newClaimSelectMenuItem"
                      key={defectType.value}
                      value={defectType.value}
                    >
                      {defectType.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
          </Grid>
          <label className="defectTypeLabel">
            Please select the type of the defect
          </label>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Unit:</label>
                <Select
                  multiple
                  className="newClaimSelect"
                  value={unitDefects}
                  onChange={handleUnitDefectChange}
                >
                  {UnitDefectTypes.map((defectType) => (
                    <MenuItem
                      className="newClaimSelectMenuItem"
                      key={defectType.value}
                      value={defectType.value}
                    >
                      {defectType.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Glass:</label>
                <Select
                  multiple
                  className="newClaimSelect"
                  value={glassDefects}
                  onChange={handleGlassDefectChange}
                >
                  {GlassDefectTypes.map((defectType) => (
                    <MenuItem
                      className="newClaimSelectMenuItem"
                      key={defectType.value}
                      value={defectType.value}
                    >
                      {defectType.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Fitting:</label>
                <Select
                  multiple
                  className="newClaimSelect"
                  value={fittingDefects}
                  onChange={handleFittingDefectChange}
                >
                  {FittingDefectTypes.map((defectType) => (
                    <MenuItem
                      className="newClaimSelectMenuItem"
                      key={defectType.value}
                      value={defectType.value}
                    >
                      {defectType.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Accessories:</label>
                <Select
                  multiple
                  className="newClaimSelect"
                  value={accessoriesDefects}
                  onChange={handleAccessoriesDefectChange}
                >
                  {AccessoriesDefectTypes.map((defectType) => (
                    <MenuItem
                      className="newClaimSelectMenuItem"
                      key={defectType.value}
                      value={defectType.value}
                    >
                      {defectType.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={4}>
              <div className="newClaimItem">
                <label>*Problem Description:</label>
                <textarea
                  type="text"
                  className={validInfo.description === true ? "" : "error"}
                  rows="9"
                  placeholder="Please accurately describe your complaint and deficiencies, specify products, quantities, etc."
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={2}>
              <div className="newClaimItem">
                <label>Damaged glass location:</label>
                <img
                  src={glass_arrangement}
                  className="glassArrangementImage"
                  alt="glass arrangement"
                />
                <Select
                  multiple
                  className="newClaimSelect"
                  value={glassDamageLocation}
                  onChange={handleGlassDamageLocationChange}
                >
                  {GlassLocations.map((defectType) => (
                    <MenuItem
                      className="newClaimSelectMenuItem"
                      key={defectType.value}
                      value={defectType.value}
                    >
                      {defectType.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Upload attachment:</label>
                <div className="attachmentTip">
                  Please upload visuals of the defects that clearly reveal
                  deficiency: closeup images and pictures with the whole
                  product.
                </div>
                <Dropzone
                  onDrop={(acceptedFiles) =>
                    handleImageSelection(acceptedFiles)
                  }
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div className="newClaimDrop" {...getRootProps()}>
                        <input {...getInputProps()} />
                        <p>Drag and Drop</p>
                        <p>or</p>
                        <p>Click to Select</p>
                      </div>
                    </section>
                  )}
                </Dropzone>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className="newClaimItem">
                <label>Attachments:</label>
                <div className="attachmentContainer">
                  {images.map((file) => (
                    <div className="imageCard" key={file.path}>
                      {file.name}
                      <DeleteIcon
                        className="deleteAttachment"
                        onClick={() => handleAttachmentRemove(file.path)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>

          <div className="newClaimFooter">
            <button
              className="registerNewClaimButtom"
              onClick={handleNewClaimSubmit}
              disabled={isFetching}
            >
              Send
            </button>
            <p>{errorMsg}</p>
          </div>
        </form>
      </div>
    </div>
  );
}
